export default {
  LEGACY_ROUTE: '/link.php?contactus',
  FAQ_LINK: '/faq-help',
  OLD_FAQ_LINK: '/link.php?faq-help',
  SUBMIT_SERVICE_URL: '/api/submit-contact-form'
};
